const options = {
    rootClass: 'zp-read-more',
    initType: 1
};

LoaderFactory(options, (function (w, d, $, undefined) {

    const _w = $(w);
    const _d = $(d);

    class ReadMore {


        /**
         * Konstruktor
         * @param {Selector} root
         */
        constructor(root) {
            this.root = root;

            this.text = $('#' + this.root.attr('id') + ' .zp-read-more-text');
            this.textInner = $('#' + this.root.attr('id') + ' .zp-read-more-text-inner');
            this.clickableText = $('#' + this.root.attr('id') + ' .zp-read-more-clickable-text');
            this.arrow = $('#' + this.root.attr('id') + ' .zp-read-more-arrow');

            this.start();
        }


        /**
         * foo
         * @param {Selector} root
         */
        start(root) {

            let clickableTextHeight = this.clickableText.height();

            this.text.css('transform','translateY(-'+clickableTextHeight+'px)');

            this.clickableText.on('click', () => {

                let textInnerHeight = this.textInner.height();

                this.clickableText.addClass('hidden');
                this.arrow.addClass('hidden');
                this.text.css('max-height', textInnerHeight+'px');

            });

            _w.on('resize', () => {

                this.onResize();

            });

        }

        onResize () {

            let textInnerHeight = this.textInner.height();

            if (this.clickableText.hasClass('hidden')) {

                this.text.css('max-height', textInnerHeight+'px');

            }

        }


    }

    return ReadMore;

}(window, document, jQuery)));